import { ResourcesManager, Viewer } from '@verybigthings/vbt-webvr-framework';
import { BackSide, DoubleSide, MeshStandardMaterial, PMREMGenerator, sRGBEncoding } from 'three';
class MaterialImprovementClass {
    constructor() { }
    init() {
        if (Viewer.zSpace || window['quality'] === 'very low')
            return;
        const texture = ResourcesManager.getTexture('background');
        texture.encoding = sRGBEncoding;
        this.pngCubeRenderTarget = new PMREMGenerator(Viewer.renderer).fromEquirectangular(texture);
    }
    upgradeMaterialsFromModel(model, levelName) {
        model.traverse(el => {
            if (el.userData.improveMaterialIgnore)
                return;
            if (el.isMesh) {
                if (el.name.includes('pPlane')) {
                    if (Viewer.zSpace || window['quality'] === 'very low') {
                        el.parent.remove(el);
                        el.geometry.dispose();
                        el.material.dispose();
                        return;
                    }
                    if (el.name === 'pPlane5' && !(el.material.name.includes('plane_mat25')))
                        el.position.y = 0.6;
                    switch (el.material.name) {
                        case 'plane_mat2':
                            el.position.y = 0.04;
                            break;
                        case 'plane_mat25':
                            el.position.y = 0.02;
                            break;
                        case 'plane_mat31':
                            el.position.y = 0.02;
                            break;
                        case 'plane_mat5':
                            el.position.y = 0.02;
                            break;
                        case 'plane_mat6':
                            el.position.y = 0.04;
                            break;
                        case 'plane_mat32':
                            el.position.y = 0.03;
                            break;
                        case 'plane_mat41':
                            el.position.y = 0.02;
                            break;
                        case 'plane_mat43':
                            el.position.y = 0.01;
                            break;
                        case 'plane_mat45':
                            el.position.y = 0;
                            break;
                        case 'plane_table_mat':
                            el.position.y = -.16;
                            el.material.opacity = .8;
                            break;
                        case 'plane_table_mat2':
                            el.position.y = 0.07;
                            el.material.opacity = .6;
                            break;
                        case 'plane_table_mat3':
                            el.position.y = 1.94;
                            break;
                        case 'plane_table_mat4':
                            el.position.y = 0;
                            el.material.opacity = .62;
                            break;
                        case 'plane_table_mat5':
                            el.position.set(0, -.1, 1.08);
                            el.scale.set(.96, 1, 1);
                            el.material.opacity = .54;
                            break;
                    }
                    el.name = 'pPlane';
                }
                else if (!el.name.includes('table')) {
                    return;
                }
                if (Viewer.zSpace && el.name.includes('table')) {
                    if (el.material.length) {
                        el.material.forEach((material, index) => {
                            el.material[index].color.set(0xb1a6da);
                        });
                    }
                    else {
                        el.material.color.set(0xb1a6da);
                    }
                }
                if (Viewer.zSpace || window['quality'] === 'very low') {
                    if (el.material.length) {
                        el.material.forEach((material, index) => {
                            if (el.material[index].normalMap) {
                                el.material[index].normalMap.dispose();
                            }
                        });
                    }
                    else {
                        if (el.material.normalMap) {
                            el.material.normalMap.dispose();
                        }
                    }
                    return;
                }
                if (el.material.length) {
                    el.material.forEach((material, index) => {
                        const newMaterial = MaterialImprovement.materialImprovement(el.material[index], el, levelName);
                        if (newMaterial) {
                            el.material[index].dispose();
                            el.material[index] = newMaterial;
                        }
                    });
                    // @ts-ignore
                    if (el.name === 'flask')
                        el.material[0].side = BackSide;
                }
                else {
                    const newMaterial = MaterialImprovement.materialImprovement(el.material, el, levelName);
                    if (newMaterial) {
                        el.material.dispose();
                        el.material = newMaterial;
                    }
                    if (el.material.name === 'phong10') {
                        el.material.opacity = 1;
                        el.material.transparent = false;
                    }
                }
            }
        });
    }
    materialImprovement(material, el, levelName) {
        if (Viewer.zSpace || window['quality'] === 'very low')
            return material;
        const map = ResourcesManager.getTexture('MAP_' + material.name);
        const normalMap = ResourcesManager.getTexture('NORMAL_' + material.name);
        const alphaMap = ResourcesManager.getTexture('ALPHA_' + material.name);
        // preLevelTextureAdjustment ===============
        if (this.preLevelTextureAdjustment(material, el, levelName))
            return;
        if (el.name.includes('table')) {
            material = new MeshStandardMaterial({
                color: 0xcbcbcb,
                opacity: material.opacity,
                transparent: material.transparent,
                name: material.name,
                roughness: 0.25,
                metalness: 0.5,
                side: DoubleSide,
                envMap: this.pngCubeRenderTarget.texture,
                map: ResourcesManager.getTexture('table_low_DefaultMaterial_BaseColor'),
                normalMap: ResourcesManager.getTexture('table_low_DefaultMaterial_Normal'),
                roughnessMap: ResourcesManager.getTexture('table_low_DefaultMaterial_Roughness'),
            });
        }
        else {
            material = new MeshStandardMaterial({
                color: material.color,
                opacity: material.opacity,
                transparent: material.transparent,
                name: material.name,
                roughness: 0.25,
                metalness: 0.5,
                side: DoubleSide,
                envMap: this.pngCubeRenderTarget.texture,
                map: map || material.map || null,
                normalMap: normalMap || material.normalMap || null,
            });
        }
        // postLevelTextureAdjustment ===============
        this.postLevelTextureAdjustment(material, el, levelName);
        return material;
    }
    preLevelTextureAdjustment(material, el, levelName) {
        if (Viewer.zSpace || window['quality'] === 'very low')
            return;
        const alphaMap = ResourcesManager.getTexture('ALPHA_' + material.name);
        if (levelName === 'MOLAR LEVEL' || levelName === 'Level_4') {
            if (material.name.includes('lambert') && alphaMap) {
                material.color.set(0x777777);
                material.transparent = true;
                material.alphaMap = alphaMap || null;
                material.alphaMap.name = 'ALPHA_' + material.name;
                return true;
            }
        }
        else {
            if (material.name.includes('plane_mat') && alphaMap) {
                // material.color.set(0x333333);
                material.transparent = true;
                material.alphaMap = alphaMap || null;
                material.alphaMap.name = 'ALPHA_' + material.name;
                el.raycast = () => { };
                return true;
            }
            else {
                if (material.name.includes('plane_table_mat') && alphaMap) {
                    // material.color.set(0x333333);
                    material.transparent = true;
                    material.alphaMap = alphaMap || null;
                    material.alphaMap.name = 'ALPHA_' + material.name;
                    return true;
                }
            }
        }
    }
    postLevelTextureAdjustment(material, el, levelName) {
        if (Viewer.zSpace || window['quality'] === 'very low')
            return;
        // for AO_MAP
        // const uvs = (<BufferGeometry>(<Mesh>el).geometry).getAttribute('uv');
        // (<BufferGeometry>(<Mesh>el).geometry).addAttribute('uv2', new BufferAttribute(uvs.array, 2));
        if (el.name.includes('table')) {
            if (el.material[0])
                el.material[0].roughness = 0.25;
        }
        if (levelName === 'ppe_level') {
            if (el.name.includes('_glove') || el.name === 'stack_of_clothes') {
                material.roughness = 0.7;
                material.metalness = 0.4;
            }
            if (el.name.includes('table') && el.material[0])
                el.material[0].color.addScalar(0.1);
        }
        if (levelName === 'MOLAR LEVEL') {
            if (el.name.includes('table') && el.material[0])
                el.material[0].color.set(0xcbcbcb);
        }
        if (['test_tube_empty', 'test_tube_blue', 'test_tube_red'].includes(levelName)) {
            let glassMaterial;
            if (levelName === 'test_tube_empty')
                glassMaterial = material;
            if (['test_tube_blue', 'test_tube_red'].includes(levelName))
                glassMaterial = el.material[0];
            glassMaterial.side = BackSide;
            glassMaterial.roughness = 0;
            glassMaterial.metalness = 0;
        }
    }
}
const MaterialImprovement = new MaterialImprovementClass();
export { MaterialImprovement };
